<template lang="html">

	<section class="home">

		<section class="intro-home column-start">
			<span class="background"></span>
			<div class="container row-start">
				<div class="contenedor-info-intro">
					<h1>{{ $t('home.intro.hashtag') }}</h1>
					<div class="row-center buttons-intro">
						<router-link class="btn -skull-orange -gray-c" :to="$t('enlaces.tarifas_luz')">
							{{ $t('home.suministros.btnShowRates') }}
						</router-link>
						<router-link class="btn -skull-orange -gray-c" :to="$t('enlaces.simulador')">
							{{ $t('header.general.submenu.tarifas.autoconsumo.calculadora') }}
						</router-link>
					</div>
				</div>
			</div>

			<div class="imagenes-intro-home row-end">
				<div class="imagen -imagen-1" v-if="!!noticiaDestacada">
					<img class="imagen -imagen-1" :src="noticiaDestacada.img.enlace" :alt="noticiaDestacada.titulo">
					</img>
					<router-link class="btn -skull-orange -gray-c"
						:to="`${$t('enlaces.blog')}/${noticiaDestacada.slug}`">
						{{ $t('home.intro.postBtn') }}
					</router-link>
				</div>
				<div class="imagen -imagen-2">
					<h2>{{ $t('home.intro.company.title') }}</h2>
					<router-link class="btn -skull-orange -gray-c" :to="$t('enlaces.empresas')">
						{{ $t('home.intro.company.btn') }}
					</router-link>
				</div>
			</div>
		</section>

		<banner-somos-hacemos class="banner-somos-hacemos-responsive"></banner-somos-hacemos>

		<section class="sliders-home">
			<slider-suministros></slider-suministros>
			<slider-instalaciones></slider-instalaciones>
		</section>

		<banner-somos-ventajas></banner-somos-ventajas>

		<noticias-home></noticias-home>

		<banner-dicen-de-nosotros></banner-dicen-de-nosotros>
		<banner-somos-hacemos class="banner-somos-hacemos-desktop"></banner-somos-hacemos>
	</section>

</template>

<script lang="js">

import sliderSuministros from '@/components/parts/slider-suministros';
import sliderInstalaciones from '@/components/parts/slider-instalaciones';

const bannerSomosAhorro = () => import('@/components/parts/banner-somos-ahorro');
const bannerSomosVentajas = () => import('@/components/parts/banner-somos-ventajas');
const bannerDicenDeNosotros = () => import('@/components/parts/banner-dicen-de-nosotros');
const bannerSomosHacemos = () => import('@/components/parts/banner-somos-hacemos');
const noticiashome = () => import('@/components/parts/noticias-home');

import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'home',
	mounted() {
		this.requestNoticiaDestacada()
	},
	data: () => ({
	}),
	components: {
		'banner-somos-ahorro': bannerSomosAhorro,
		'banner-somos-ventajas': bannerSomosVentajas,
		'banner-dicen-de-nosotros': bannerDicenDeNosotros,
		'slider-suministros': sliderSuministros,
		'slider-instalaciones': sliderInstalaciones,
		'noticias-home': noticiashome,
		'banner-somos-hacemos': bannerSomosHacemos
	},
	computed: {
		...mapGetters({
			noticiaDestacada: 'getNoticiaDestacada'
		})
	},
	methods: {
		...mapActions([ 'requestNoticiaDestacada'])
	}

}
</script>

<style scoped>
.container {

	position: relative;
	z-index: 6;
	width: 100%;
}

.contenedor-info-intro {
	position: relative;
	left: 0;
	bottom: 0;
	display: inline-block;
	padding-bottom: 140px;
}

.imagen.-imagen-3 {
	position: relative;
}

.imagen video {
	width: 100%;
	display: inline-block;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	transition: .5s;
}

@media screen and (max-width: 600px) {
	.container {
		padding: 0;
	}

	.contenedor-info-intro {
		padding-bottom: 0;
		display: -webkit-flex;
		display: -moz-flex;
		display: -ms-flex;
		display: -o-flex;
		display: flex;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/views/home.vue